const palette = {
  primary: {
    main: "#96F3A2",
    contastText: "#FFFFFF",
  },
  secondary: {
    main: "#084A4A",
    contastText: "#FFFFFF",
  },
  text: {
    primary: "#FFFFFF",
    
  },
  success: {
    main: "#0E912C",
  },
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
};

export default palette;
